import React from 'react';
import {
  isNextMonthDisabled,
  isPrevMonthDisabled,
} from 'src/components/CustomToolbar/helpers';

interface CustomToolbarProps {
  date: Date;
  label: string;
  onNavigate: (action: 'PREV' | 'NEXT' | 'TODAY' | 'DATE', date?: Date) => void;
  minDate?: Date;
  maxDate?: Date;
}

// Simplified CustomToolbar component for monthly view only
const CustomToolbar = ({
  date,
  label,
  onNavigate,
  minDate,
  maxDate,
}: CustomToolbarProps) => {
  const prevDisabled: boolean = isPrevMonthDisabled(minDate, date);
  const nextDisabled: boolean = isNextMonthDisabled(maxDate, date);

  const goToPrevious = () => {
    if (prevDisabled) return;
    onNavigate('PREV');
  };

  const goToNext = () => {
    if (nextDisabled) return;
    onNavigate('NEXT');
  };

  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group">
        <button
          type="button"
          onClick={goToPrevious}
          disabled={prevDisabled}
          className={prevDisabled ? 'rbc-btn-disabled' : ''}
        >
          Back
        </button>
        <button
          type="button"
          onClick={goToNext}
          disabled={nextDisabled}
          className={nextDisabled ? 'rbc-btn-disabled' : ''}
        >
          Next
        </button>
      </span>
      <span className="rbc-toolbar-label">{label}</span>
    </div>
  );
};

export default CustomToolbar;
